import React, { useEffect, useState } from "react";
import { Col, Row, Tab, ToastContainer, Breadcrumb } from "react-bootstrap";
import { HomeIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import { Routes } from "routes";
import { Toast } from "react-bootstrap";
import { IoArrowBackCircle } from "react-icons/io5";
import { useUserDropDownMutation } from "Services/services";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { DefulatRoutingSmscListTable } from "components/Tables";

export default () => {
  const [userDetails] = useUserDropDownMutation();
  //usertype
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(
    location.state?.activeTab || "SMS"
  ); //toaster info
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  //functional details
  const [formData, setFormData] = useState({
    enterprise: "",
    routeName: "",
    channel: "",
  });
  const [selectedUserOptions, setSelectedUserOptions] = useState({
    value: "",
    label: "Select Users",
  });
  const selectedChannelOptions = [
    { value: "", label: "Select Channel" },
    { value: "SMS", label: "SMS" },
    { value: "Whatsapp", label: "Whatsapp" },
  ];

  // functional programming

  useEffect(() => {
    const fetchEnterpriceList = async () => {
      try {
        const response = await userDetails({ user_type: 4 });
        if (response?.data?.statusCode === 200) {
          const options = response.data.data.user_details.map((user) => ({
            value: user.id,
            label: `${user.user_name} (${user.email})`,
          }));
          // Add a default "Select CRM" option at the beginning of the options array
          setSelectedUserOptions([
            { value: "", label: "Select Users" },
            ...options,
          ]);
        } else {
          console.error("Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };

    fetchEnterpriceList();
  }, []);

  // 🔁 Single dynamic handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Row>
        <Col xs={12} xl={12}>
          <DefulatRoutingSmscListTable />
        </Col>
      </Row>
    </>
  );
};
